import React from 'react';
import { motion } from 'framer-motion';
import { highlightTerms } from '../highlightTerms';
import { Play } from 'lucide-react';

export const ClosingSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.3, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: 'easeOut' } },
  };

  return (
    <div
      className="h-full w-full flex flex-col justify-center items-center px-8 md:px-12 lg:px-20 py-12 relative"
      data-testid={`slide-${slide.id}`}
    >
      {/* Background glow effect */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[600px] h-[600px] bg-[#D31113]/10 rounded-full blur-[150px]" />
      </div>

      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-4xl w-full text-center relative z-10"
      >
        {slide.subtitle && (
          <motion.p
            variants={itemVariants}
            className="font-sans text-lg md:text-xl text-[#D31113] uppercase tracking-[0.3em] mb-6 font-semibold"
          >
            {slide.subtitle}
          </motion.p>
        )}

        <motion.h2
          variants={itemVariants}
          className="pres-font-heading text-5xl md:text-6xl lg:text-8xl font-black uppercase tracking-tight text-white mb-12 leading-none"
        >
          {highlightTerms(slide.title)}
        </motion.h2>

        {slide.quote && (
          <motion.div
            variants={itemVariants}
            className="mb-16"
          >
            <blockquote className="font-sans text-xl md:text-2xl text-gray-200 italic leading-relaxed max-w-3xl mx-auto">
              "{highlightTerms(slide.quote)}"
            </blockquote>
          </motion.div>
        )}

        <motion.div
          variants={itemVariants}
          className="inline-flex items-center gap-4"
        >
          <div className="w-20 h-20 rounded-full bg-[#D31113] flex items-center justify-center shadow-lg shadow-[#D31113]/50 animate-pulse">
            <Play className="w-8 h-8 text-white ml-1" fill="white" />
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};
